import {
  CLEAR_RECOMENDATIONS,
  FETCH_CONTENT_RECOMENDATIONS_ERROR,
  FETCH_CONTENT_RECOMENDATIONS_INIT,
  FETCH_CONTENT_RECOMENDATIONS_SUCCESS,
} from 'containers/Player/actions/recomendations/constants';

const initialState = {
  loading: false,
  success: null,
  data: null,
}

const RecomendationsReducer = (state = initialState, action) => {
  switch (action.type){
    case FETCH_CONTENT_RECOMENDATIONS_INIT:
      return { ...initialState, loading: true };
    case FETCH_CONTENT_RECOMENDATIONS_SUCCESS:
      return { ...state, loading: false, data: action.data };
    case FETCH_CONTENT_RECOMENDATIONS_ERROR:
      return { ...initialState, error: action.error };
    case CLEAR_RECOMENDATIONS:
      return { ...initialState }
    default:
      return state;
  }
}

export default RecomendationsReducer;
